import axios from 'axios';

// Create a clean axios instance without ShipStation interceptors for Shopify API calls
export const shopifyAxios = axios.create();
